<template>
  <div>
    <bsp-table ref="accountTable"
               :data.sync="contractLists" :ciic-data-filter.sync="listQuery"
               show-header-overflow show-overflowwidth
               show-overflow
               v-loading="loading"
               element-loading-text="拼命加载中"
               element-loading-spinner="el-icon-loading"
               show-footer-overflow
               show-footer :footer-method="footerMethod" 
               :showPagination="false"
               fixed="left">
      <vxe-table-column fixed="left" type="index" title="序号" width="60" align="center"/>
      <bsp-table-column field="id" title="合同编号" width="200px" align="center" fixed="left"
                        :slot-filter="false" filter-type="input" >
        <template slot-scope="scope"><span>{{ scope.row.id }}</span></template>
      </bsp-table-column>
      <bsp-table-column field="name" title="合同名称" width="200px" align="center" fixed="left"
                        :slot-filter="false" filter-type="input" >
        <template slot-scope="scope"><span>{{ scope.row.name }}</span></template>
      </bsp-table-column>
      <!-- <bsp-table-column field="typeCon" title="业务类型" width="150px" align="center" fixed="left"
                        :slot-filter="false" filter-type="input" >
        <template slot-scope="scope"><span>{{ scope.row.typeCon }}</span></template>
      </bsp-table-column> -->
      <bsp-table-column title="操作" width="150px" fixed="right" align="center">
        <template slot-scope="scope">
          <div class="ciic-table-operate">
            <el-button type="text" @click="exportRow(scope.row)" :key="scope.row">{{exportOrMail == 'mail' ? '发送' : '导出'}}</el-button>
          </div>
        </template>
      </bsp-table-column>
    </bsp-table>

  </div>
</template>

<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import { getXcInfoExcel } from "@/api/biz/salaryBatchInfo";
  import { downloadFile } from '@/util/util';
  import { sendPayNotMail } from "@/api/biz/bill/pay-notice"
  
  export default {
    name: "contractTable",
    components: {bspTableColumn, bspTable,},
    props:{
      balanceInfo:{
        type: Object,
        default: () => ({})
      },
      clickRow:{
        type: Object,
        default: () => ({})
      },
      contractLists: {
        type: Array,
        default: () =>([])
      },
      exportOrMail: {
        type: String,
        default: ''
      },
      balanceListsCopy2: {
        type: Array,
        default: () =>([])
      },
      kyBalanceList: {
        type: Array,
        default: () =>([])
      },
    },
    computed: {
    },
    created() {
    },
    data(){
      return{
        multipleSelection: [],
        contractList: [
          {id: '152156984512', name: '总工会和分公司劳动分配合同', typeCon: '财税类'},
          {id: '152156126518', name: '2020年第一季度合同', typeCon: '财税类'},
          {id: '152111984514', name: '2021年相关材料合同', typeCon: '薪酬类'},
          {id: '152151114534', name: '财务审核相关合同', typeCon: '薪酬类'},
          {id: '152159994519', name: '水库文化项目付款合同', typeCon: '财务类'},
        ],
      }
    },
    methods: {
        // 复选框单选事件
      // selectChange({checked, row}) {
      //   if (checked) {
      //     this.multipleSelection.push(row.id)
      //   }
      //   if (!checked) {
      //     this.multipleSelection.filter((item, index) => {
      //       if (item === row.id) {
      //         this.multipleSelection.splice(index, 1)
      //       }
      //     })
      //   }
      // },
      exportRow(row) {
        let param = {
          payNoticeId: this.clickRow.id,
          id: this.clickRow.id,
          isOtherBiz: this.clickRow.isOtherBiz=='10020001' ? true : false,
          contractCode: row.id,
          contractType: '业务类型',
        }
        if (this.exportOrMail == 'mail') {
          sendPayNotMail(param).then(res => {
            if (res.data.data) {
              this.$message.success("邮件发送成功！");
              this.$emit('contractTableDialog',{id: param,});
            } else {
              this.$message.warning("邮件发送失败！");
            }
          })
        } else {
          getXcInfoExcel(param).then(res => {
            downloadFile(res)
            this.$message.success("导出成功！");
            this.$emit('contractTableDialog',{id: param,});
          })
        }
      }
    },
    filters: {
      
    },
    mounted(){

    },
    watch: {
        
    },
  };
</script>

<style>

</style>
